export default "__VITE_ASSET__B$31kwFw__"